import type { InitialFilterState } from '../../../common/search/store/AbstractFilter';
import AbstractFilter from '../../../common/search/store/AbstractFilter';

export default class SortByPriceFilter extends AbstractFilter {
    static NAME = 'sortByPrice';

    #direction: string | null = null;

    get parameters(): Record<string, string | null> {
        if (this.#direction === null) {
            return { sortField: null, sortOrder: null };
        }

        return { sortField: 'price', sortOrder: this.#direction };
    }

    set direction(direction: string | null) {
        if (this.#direction === direction) return;

        this.#direction = direction;
        this.notify();
    }

    public clear(): void {
        this.#direction = null;
        this.notify();
    }

    public setInitialState(state: InitialFilterState): void {
        const sortField = state.get('sortField');
        const sortOrder = state.get('sortOrder');
        this.#direction = sortField === 'price' ? sortOrder || null : null;
    }
}
